import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../environments/environment";
import { SessionStorageService } from "../shared/services/session-storage.service";

export function initializeApp(
  cookieService: CookieService,
  sessionStorageService: SessionStorageService,
  httpClient: HttpClient
) {
  return (): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      
      deleteAllCookiesExcept(["consentRejected", "AWSALBTG", "AWSALBTGCORS"], cookieService);
      
      try {
        let token = "";
        if (environment.local) {
          const localToken: any = await httpClient.get(environment.localTokenServer).toPromise();
          token = localToken.token;
        } else {
          const dateString = new Date().toISOString();
          const urlWithUuid = `${environment.api_auth_token_url}?req_id=${dateString}`;
          const localToken: any = await httpClient.get(urlWithUuid).toPromise();
          token = localToken?.access_token;
        }

        sessionStorageService.token = token;

        if (!environment.production) {
          console.log("Cookie value" + token);
        }
      }
      catch (error) {
        console.log(error);
        console.log("Cookie not found");
      }
      resolve();
    });

  }


  function deleteAllCookiesExcept(cookiesToKeep: string[], cookieService: CookieService) {
    // Only delete cookies if the user has rejected consent on the parent domain.
    // The "consentRejected" cookie is set on ".texascapitalbank.com" by the
    // cookie consent banner and is inherited by subdomains like join.texascapitalbank.com.
    if (!cookieService.check('consentRejected')) {
      return;
    }

    // Parent domains whose cookies need to be cleared on arrival at this app.
    const parentDomains = ['.texascapitalbank.com', '.baskbank.com'];

    // document.cookie lists all cookies accessible to the current subdomain,
    // including those inherited from parent domains.
    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
      const name = cookie.split('=')[0].trim();
      // Skip cookies that should be preserved:
      // - consentRejected: user's consent preference
      // - AWSALBTG, AWSALBTGCORS: AWS load balancer stickiness — functional infrastructure cookies
      if (!name || cookiesToKeep.includes(name)) {
        continue;
      }

      // Delete from the current subdomain (same-site cookies like _spdt).
      // This matches the parent domain behaviour when consent is declined.
      cookieService.delete(name, '/');

      // Delete from each parent domain (inherited cookies like _ga*, _sfid_*, etc.).
      for (const domain of parentDomains) {
        cookieService.delete(name, '/', domain);
      }
    }
  }
}
